import React, { useEffect } from 'react';
import axios from 'axios';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import InputGroup from '../../Components/InputGroup';
import OrderTable from '../../Components/OrderTable';
import Pagination from '../../Components/Pagination';

const orderAPI = '/api/v1/orders/';

export const queryOrders = async (filter: string, query: string) => {
  let res;
  const getConfig = async () => {
    const config = {
      headers: {
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      },
    };
    return config;
  };
  
  try {
    const config = await getConfig();
    const lowercaseFilter = filter.toLowerCase();
    const queryCall = `?${lowercaseFilter}__icontains=${query}`;
    if (query.length < 1) {
      res = await axios.get(`${orderAPI}`, config);
    } else {
      res = await axios.get(`${orderAPI}${queryCall}`, config);
    }
  } catch (e) {
    return e;
  }
  return res;
};

const messageTimeout = () => {
  const timer = setTimeout(() => {
    sessionStorage.setItem('message', '');
  }, 500);
  return () => clearTimeout(timer);
};

export const renderMessage = () => {
  const messageExists = sessionStorage.getItem('message');
  const messageType = sessionStorage.getItem('messageType');
  messageTimeout();
  if (messageExists === '') return null;
  if (messageType === 'Success') {
    return (
      <div className='alert alert-success text-center' role='alert'>
        {messageExists}
      </div>
    );
  } if (messageType === 'Fail') {
    return ( 
      <div className='alert alert-danger text-center' role='alert'>
        {messageExists}
      </div>
    );
  }
  return true;
};

const OrderSearch = () => {
  const history = useHistory();
  const [value, setValue] = React.useState('');
  const [filter, setFilter] = React.useState('customer_name');
  const [orders, setOrders] = React.useState([]);
  const [totalItems, setItems] = React.useState(0);
  const [nextPage, setNextPage] = React.useState(null);
  const [previousPage, setPreviousPage] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const { msg, msg_type } = useSelector((state: any) => state.orders);
  const dispatch = useDispatch();

  React.useEffect(() => {
    // Create an scoped async function in the hook
    async function fetchOrders() {
      const res = await queryOrders(filter, value);
      if (res.status === 200) {
        const {
          results, count, next, previous, 
        } = res.data;
        let nextVal, prevVal;
        setOrders(results);
        if (results.length > 0) {
          setItems(count);
          if (next !== null) nextVal = next.split(':8000')[1]; // eslint-disable-line
          if (previous !== null) prevVal = previous.split(':8000')[1]; // eslint-disable-line
          setNextPage(nextVal || next);
          setPreviousPage(prevVal || previous);
          return results;
        } 
        setValue('');
        return results;
      }
      setValue('');
      return res;
    }
    // Execute the created function directly
    fetchOrders();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (msg.length) {
      setTimeout(() => {
        dispatch({ type: 'RESET_ORDER_MSG' });
      }, 5000);
    }
  }, [msg]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const onSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilter(e.target.name);
  };

  const handlePagination = async (url: any) => {
    let res;
    const urlPage = url.split('=')[1];
    if (isNaN(urlPage)) {// eslint-disable-line
      setCurrentPage(1);
    } else {
      setCurrentPage(Number(urlPage));
    }
    const getConfig = async () => {
      const config = {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`,
        },
      };
      return config;
    };
      
    try {
      const config = await getConfig();
      res = await axios.get(url, config);
      if (res.status === 200) {
        const {
          results, count, next, previous, 
        } = res.data;
        let nextVal, prevVal;
        setOrders(results);
        if (results.length > 0) {
          setItems(count);
          if (next !== null) nextVal = next.split(':8000')[1]; // eslint-disable-line
          if (previous !== null) prevVal = previous.split(':8000')[1]; // eslint-disable-line
          setNextPage(nextVal || next);
          setPreviousPage(prevVal || previous);
          return results;
        } 
        setValue('');
        return results;
      }
    } catch (e) {
      return e;
    }
    return res;
  };

  const exportSearch = async (e: any) => {
    e.preventDefault();
    let res;
    const csvAPI = '/api/v1/orders-csv/';
    
    try {
      const lowercaseFilter = filter.toLowerCase();
      const queryCall = `?${lowercaseFilter}__icontains=${value}`;
      if (value.length < 1) {
        res = await axios({
          url: `${csvAPI}`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
          responseType: 'blob',
        });
      } else {
        res = await axios({
          url: `${csvAPI}${queryCall}`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`,
          },
          responseType: 'blob',
        });
      }
    } catch (error) {
      return error;
    }
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'export.csv');
    document.body.appendChild(link);
    link.click();
    return res;
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    const res = await queryOrders(filter, value);
    if (res.status === 200) {
      setOrders(res.data.results);
      if (res.data.results.length > 0) {
        setItems(res.data.count);
        setCurrentPage(1);
        setNextPage(res.data.next);
        setPreviousPage(res.data.previous);
        return res.data.results;
      } 
      setValue('');
      return res.data.results;
    }
    setValue('');
    return res;
  };

  const modifiyPage = () => {
    if (currentPage > 1) {
      return ((currentPage - 1) * 25 + 1);
    } 
    return currentPage;
  };

  const pageModifier = modifiyPage();
  return (
    <div>
      <div className='search-container'>
        <div className='row mb-3'>
          <div className='col-8'>
            <h3>Orders</h3>
          </div>
        </div>
        {msg.length ? (
          <div className={`alert alert-${msg_type} text-center`} role='alert'>
            {msg}
          </div>
        ) : null}
        <InputGroup
          history={history}
          onChange={onChange}
          value={value}
          onSubmit={onSubmit}
          onSelect={onSelect}
          selectedFilter={filter}
          filters={[]}
          exportSearch={exportSearch}
          type='Order'
          link='order'
        />
        <OrderTable orders={orders} fetchMore={onSubmit} pageModifier={pageModifier} />
        <Pagination totalItems={totalItems} next={nextPage} previous={previousPage} handlePagination={handlePagination} currentPage={currentPage} />
      </div>
    </div>
  );
};

export default OrderSearch;
